import React from "react";
import { ReactTypeformEmbed } from "react-typeform-embed";

const ContactPage = () => (
  <ReactTypeformEmbed url="https://garyli.typeform.com/to/J9C865" hideHeaders hideFooter />
);

export default ContactPage;
